import React from "react";

// In-app time picker (Hours + Minutes dropdowns). Avoids the native
// Android time dialog whose confirm button can get clipped on some phones.
export function TimeSelect({ value, onChange, testId, minuteStep = 5, className = "" }) {
  const parts = (value || "").split(":");
  const h = parts[0] ?? "";
  const m = parts[1] ?? "";

  const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
  const mins = Array.from({ length: Math.floor(60 / minuteStep) }, (_, i) => String(i * minuteStep).padStart(2, "0"));
  if (m && !mins.includes(m)) mins.push(m); // keep an existing non-standard minute selectable

  const selCls =
    "flex-1 bg-[#111] border border-white/10 rounded-[10px] h-10 px-2 text-sm text-white font-mono-clock outline-none focus:border-[#007BFF] cursor-pointer";

  return (
    <div className={`flex items-center gap-1.5 mt-1 ${className}`}>
      <select
        data-testid={testId ? `${testId}-hour` : undefined}
        value={h}
        onChange={(e) => onChange(`${e.target.value}:${m || "00"}`)}
        className={selCls}
        aria-label="Heures"
      >
        <option value="" disabled>HH</option>
        {hours.map((x) => (
          <option key={x} value={x} className="bg-[#111]">{x}</option>
        ))}
      </select>
      <span className="text-white/40 font-mono-clock">:</span>
      <select
        data-testid={testId ? `${testId}-minute` : undefined}
        value={m}
        onChange={(e) => onChange(`${h || "00"}:${e.target.value}`)}
        className={selCls}
        aria-label="Minutes"
      >
        <option value="" disabled>MM</option>
        {mins.sort().map((x) => (
          <option key={x} value={x} className="bg-[#111]">{x}</option>
        ))}
      </select>
    </div>
  );
}
